// UI strings for Omat virheet, the cards made from your own mistakes (Axel's decision of 2026-10-09;
// app/src/ownerrors/): the card's face and its rule line, and the week hub's count. Finnish (default)
// and English side by side, the same shape. Style: docs/FINNISH-STYLE.md.
import type { OwnErrorSource } from '@valyrio/engine/types';
import { defineArea } from '../area';

const cap = (s: string) => s.charAt(0).toLocaleUpperCase('fi') + s.slice(1);

export const ownErrorsFi = {
  card: {
    /** The card's meta line: "Oma virhe · kortilla". */
    kind: 'Oma virhe',
    from: { card: 'kortilla', exercise: 'tehtävässä', dictation: 'sanelussa', letter: 'kirjeessäsi' } as Record<OwnErrorSource, string>,
    caseAsk: 'Missä sijassa sana on?',
    sayCase: 'Sano sija ääneen ja katso sitten vastaus.',
    /** Before the struck-through answer, for screen readers. */
    old: 'Aiempi vastauksesi',
    /** "Genetiivi, ei akkusatiivi." */
    rule: (asked: string, wrote: string) => `${cap(asked)}, ei ${wrote}.`,
    macrons: 'Kirjaimet olivat oikein, vain vokaalin pituus oli väärin.',
    otherWord: 'Kirjoitit toisen sanan muodon:',
    label: (asked: string) => `${cap(asked)}.`,
    times: (n: number) => `Sama virhe ${n} kertaa`,
  },
  week: {
    /** The week hub's line, only when error cards wait. */
    waiting: (n: number) => (n === 1 ? 'Omat virheet: 1 kortti odottaa tänään' : `Omat virheet: ${n} korttia odottaa tänään`),
  },
};

export const ownErrorsEn: typeof ownErrorsFi = {
  card: {
    kind: 'Your mistake',
    from: { card: 'on a card', exercise: 'in an exercise', dictation: 'in a dictation', letter: 'in your letter' },
    caseAsk: 'Which case is the word in?',
    sayCase: 'Say the case aloud, then look at the answer.',
    old: 'Your earlier answer',
    rule: (asked: string, wrote: string) => `${cap(asked)}, not ${wrote}.`,
    macrons: 'The letters were right; only a vowel length was wrong.',
    otherWord: 'You wrote a form of another word:',
    label: (asked: string) => `${cap(asked)}.`,
    times: (n: number) => `The same mistake ${n} times`,
  },
  week: {
    waiting: (n: number) => (n === 1 ? 'Your mistakes: 1 card waiting today' : `Your mistakes: ${n} cards waiting today`),
  },
};

// Messages.ownErrors (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('ownErrors', ownErrorsFi, ownErrorsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof ownErrorsFi> {}
}
